import * as React from 'react';
import {
  RadioButtonWrapper,
  RadioButtonStyled,
  RadioButtonLabel,
  RadioButtonLogo,
  RadioButtonImage,
  RadioButtonChecked
} from './styled';

interface Props {
  name?: string;
  value: string;
  label?: string;
  checked?: boolean;
  img?: string;
  imgHeight?: string;
  onChange?: Function;
}

export const RadioButton: React.FC<Props> = React.forwardRef(({
  name,
  value,
  label,
  checked,
  img,
  imgHeight,
  onChange
}, ref) => {
  const propsRef = ref && (ref.hasOwnProperty('current') || typeof ref === 'function') ? { ref } : {}
  return (
    <RadioButtonWrapper>
      <RadioButtonLabel>
        <RadioButtonStyled
          type="radio"
          name={name}
          value={value}
          defaultChecked={checked}
          {...propsRef}
          onChange={event => { onChange ? onChange(event) : null }}
        />
        <RadioButtonChecked />
        {label}
      </RadioButtonLabel>
      <RadioButtonLogo
        imgHeight={imgHeight}
      >
        <RadioButtonImage
          src={img}
        />
      </RadioButtonLogo>
    </RadioButtonWrapper>
  )
})
